import React from 'react';
import { Head, usePage } from '@inertiajs/react';
import { InertiaSharedData } from '@/types';

interface PageTitleProps {
    title: string;
}

interface PageProps {
    shared: InertiaSharedData;
}

const PageTitle: React.FC<PageTitleProps> = ({ title }) => {
    const { shared } = usePage<PageProps>().props;
    const academyName = shared?.user?.current_academy?.name || 'ConquerX';
    const fullTitle = `${title} | ${academyName}`;

    return <Head title={fullTitle} />;
};

export default PageTitle;
